// Card
export const cardReceita = 'CARD_Receita';
export const cardCupons = 'CARD_Cupons';
export const cardValorMedioProduto = 'CARD_VlMedioProduto';
export const cardValorMedioCupom = 'CARD_VlMedioCupom';
export const cardMediaItensCupom = 'CARD_MediaItensCupom';
export const cardBoleto1 = 'CARD_Boleto1';
export const cardTotalItens = 'CARD_ItensVendidos';

// Chart
export const chartEvolucaoDiariaReceita = 'CHART_EvolDiariaReceita';
export const chartEvolucaoDiariaCupon = 'CHART_EvolDiariaCupons';
export const chartReceitaPorLoja = 'CHART_ReceitasPorLoja';
export const chartQuantidadeCuponsPorLoja = 'CHART_QtdCuponsPorLoja';
export const chartMediaItensCupom = 'CHART_MediaItensCupom';
export const chartValorMediaCupom = 'CHART_VlMedioCupom';
export const chartPercentualCupon = 'CHART_PercentualCupons';
export const chartConversaoVendas = 'CHART_ConversaoVendas';
export const chartValorMedioProduto = 'CHART_VlMedioProduto';
export const compararPeriodosDash = 'CompararPeriodosDash';
export const chartEvolucaoDiariaValorMedioCupom = 'CHART_EvolDiaria_VlMedioCupom';
export const chartEvolucaoDiariaMediaItensCupom = 'CHART_EvolDiaria_MediaItensCupom';
export const chartEvolucaoDiariaValorMedioProduto = 'CHART_EvolDiaria_VlMedioProduto';
export const chartEvolDiariaItensVendidos = 'CHART_EvolDiariaItensVendidos';
export const chartQtdItensVendidosPorLoja = 'CHART_QtdItensVendidosPorLoja';

// export const dashboard = [cardReceita, cardCupons, cardValorMedioProduto, cardValorMedioCupom,cardMediaItensCupom, cardBoleto1, cardEvolucaoDiariaReceita, chartEvolucaoDiariaCupon, chartReceitaPorLoja, chartQuantidadeCuponsPorLoja, chartQuantidadeCuponsPorLoja, chartQuantidadeCuponsPorLoja]
